import axios from "axios";
import { baseUrl } from "./baseUrl";

const api = axios.create({
    baseURL: `${baseUrl}/admin/project`,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('cc-t') || sessionStorage.getItem('cc-t');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Project CRUD API
export const createProject = async (data) => {
    try {
        const res = await api.post("/create", data);
        return res.data;
    } catch (error) {
        console.error("Error creating project:", error);
        throw error;
    }
};

export const getProjects = async () => {
    try {
        const res = await api.get("/list");
        return res.data.data.projects;
    } catch (error) {
        console.error("Error fetching projects:", error);
        throw error;
    }
};

export const getProjectById = async (id) => {
    try {
        const res = await api.get(`/${id}`);
        return res.data.data;
    } catch (error) {
        console.error("Error fetching project:", error);
        throw error;
    }
};

export const updateProject = async (data) => {
    try {
        const res = await api.put(`/${data.id}`, data);
        return res.data;
    } catch (error) {
        console.error("Error updating project:", error);
        throw error;
    }
};

export const deleteProject = async (id) => {
    try {
        const res = await api.delete(`/${id}?permanent=true`);
        return res.data;
    } catch (error) {
        console.error("Error deleting project:", error);
        throw error;
    }
};

export const getPlantationProjects = async () => {
    try {
        const res = await api.get("/plantation-projects");
        return res.data.data.projects;
    } catch (error) {
        console.error("Error fetching plantation projects:", error);
        throw error;
    }
}

export const getPlantationProjectDetails = async (id) => {
    try {
        const res = await api.get(`/plantation-projects/${id}`);
        return res.data.data;
    } catch (error) {
        console.error("Error fetching plantation projects:", error);
        throw error;
    }
}

export const uploadPlantationCertificate = async (data) => {
    try {
        const res = await api.put(`/plantation-projects-upload-certificate`, data);
        return res.data;
    } catch (error) {
        console.error("Error uploading plantation certificate:", error);
        throw error;
    }
}